import React from 'react';
import { GridContainer, GridItem } from '../../components';
import { Box, CircularProgress, Fab } from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import CancelIcon from '@material-ui/icons/Cancel';
import Typography from '@material-ui/core/Typography';
import {useSearchParams, useNavigate } from 'react-router-dom';

export const ResponseFail = () => {
    
    const [isLoading, setIsLoading] = React.useState(true);
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    React.useEffect(()=>{
        searchParams.append("redirectResult", "fail");
        setSearchParams(searchParams);
    },[]);

    React.useEffect(()=>{
        const loadingTimeout = setTimeout(()=>{
            setIsLoading(false);
        },3000);

        return () => clearTimeout(loadingTimeout);
    },[searchParams, setSearchParams]);

    React.useEffect(()=>{
        if(!isLoading){
            const newURL = `/?${searchParams.toString()}`;
            navigate(newURL);
        }
    }, [isLoading, navigate]);

  return (
    <div>
        <GridContainer
            spacing={3}
            alignContent="center"
            justifyContent="center"
            direction="row"
            style={{ paddingTop: '32px', paddingLeft: '18px', paddingRight: '18px', height: '50vh' }}
        >
            <GridItem xs={12}>
            <Typography align="center" variant="h4">
                Sorry, we are unable to process your payment. 
            </Typography>
            </GridItem>
            <GridItem xs={12}>
            <Typography align="center" variant="body1">
                PLEASE TRY AGAIN...
            </Typography>
            </GridItem>
            <GridItem xs={12}>
            <Typography align="center" variant="body1" style={{ fontStyle: 'italic' }}>
                Returning you to merchant's website
            </Typography>
            </GridItem>
            <GridItem>
                <Box sx={{ m: 1, position: 'relative' }}>
                    <Fab color="secondary">
                        <CancelIcon />
                    </Fab>
                    <CircularProgress
                    size={68}
                    style={{
                        color: red[500],
                        position: 'absolute',
                        top: -6,
                        left: -6,
                        zIndex: 1
                    }}
                    />
                </Box>
            </GridItem>
        </GridContainer>
    </div>
  );
};
